/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type WellTypeEnum = 1 | 2 | 3;

export const WellTypeEnum = {
    NUMBER_1: 1 as WellTypeEnum,
    NUMBER_2: 2 as WellTypeEnum,
    NUMBER_3: 3 as WellTypeEnum
};

